import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function PostPropertyStart() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, role } = useAuth();

  const selectedType = location.state?.selectedType || null;
  const listingType = location.state?.listingType || "sale";

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", {
        replace: true,
        state: {
          from: "/post-property",
          openPostProperty: true,
          listingType,
          postPropertySource: location.state?.postPropertySource || "site",
          prompt:
            listingType === "rent"
              ? "Login to continue posting your rental property."
              : "Login to continue posting your property."
        }
      });
      return;
    }

    navigate(role === "admin" ? "/admin/queue" : "/", {
      replace: true,
      state: {
        openPostProperty: true,
        selectedType,
        listingType,
        postPropertySource: location.state?.postPropertySource || "site",
        message: location.state?.message || "Property type selected. Complete the listing form below."
      }
    });
  }, [isAuthenticated, listingType, location.state?.message, location.state?.postPropertySource, navigate, role, selectedType]);

  return null;
}
